"use client";

import TagManager from "react-gtm-module";

const init = ({ id }: { id?: string }) => {
  if (id) {
    TagManager.initialize({
      gtmId: id,
    });
  }
};

export const GoogleTagManager = {
  init,
};

export const logGoogleAnalyticsEvents = ({
  eventLabel = null,
  eventContent = null,
  eventCategory = null,
  eventAction = null,
}: {
  eventLabel?: string | null;
  eventContent?: string | null;
  eventCategory?: string | null;
  eventAction?: string | null;
}) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "custom_event",
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel,
    event_value: null,
    event_context: null,
    event_content: eventContent,
    user_id: null,
  });
};
